import React from 'react';
import { IconsList } from '../IconsList';
import { SelectAccount } from '../SelectAccount';

export const AccountSelectionStep = ({ platformCode, onBack, onConnect, onAccountSelect, selectedAccount }) => (
    <div>
        <IconsList platform={platformCode} />
        <SelectAccount
            onCancel={onBack}
            onConnect={onConnect}
            onAccountSelect={onAccountSelect}
            selectedAccount={selectedAccount}
        />
    </div>
);
